module.exports = __webpack_public_path__ + "img/BB.e6edf8d3.png";